<template>
  <div class="sticky-tabs-bar top-64px h-64px bg-white w-full border-b border-gray-30">
    <div class="container mx-auto">
      <n-tabs v-model:value="activatedTab" size="large" justify-content="start" tab-style="padding: 20px 16px">
        <n-tab v-for="tab in props.tabs" :id="`${tab.key}-tab`" :key="tab.key" :name="tab.key" @click="handleClickTab(tab.key)">
          {{ tab.label || tab.key }}
        </n-tab>
      </n-tabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NTabs, NTab } from 'naive-ui'

const activatedTab = defineModel<string>()

const emit = defineEmits<{
  (event: 'tab-change', value: string): void
}>()

const props = defineProps<{
  tabs: {
    key: string
    label?: string
  }[]
}>()

const handleClickTab = (id: string) => {
  emit('tab-change', id)
}
</script>

<style lang="scss" scoped>
.sticky-tabs-bar {
  :deep(.n-tabs) {
    .n-tabs-tab {
      @apply p-0;
    }
    .n-tabs-bar {
      @apply h-0.5;
    }

    .n-tabs-nav-scroll-wrapper {
      &.n-tabs-nav-scroll-wrapper--shadow-start::before {
        box-shadow: inset 20px 0 8px -8px rgba(white, 0.75);
      }
      &.n-tabs-nav-scroll-wrapper--shadow-end::after {
        box-shadow: inset -20px 0 8px -8px rgba(white, 0.75);
      }
    }
  }
}
</style>
